<template>
    <div class="">
        <h3 class="color_Azul family-01" v-if="(form.TipoTema == 'ENLACES')" >{{form.Titulo}}</h3> 
        <hr v-show="(form.TipoTema == 'ENLACES' && form.Titulo !='')" class="divider-02 hr-sm-left-0 bg-color"> 
        <h5 v-show="(form.TipoTema == 'ENLACES' && form.Subtitulo !='')" class="color_Azul">{{form.Subtitulo}}</h5> 
        <div v-if="(form.TipoTema == 'ENLACES')" >                           
            <div v-if="(form.detContenidoTema.length>0)">
                <template v-if="(form.detContenidoTema[0].Tipo == 'INFOGRAFIA')">
                    <CInfo v-model="form.images"></CInfo>
                </template>

                <div class="row mb-4 list-icon" v-if="(form.detContenidoTema[0].Tipo == 'ENLACEIMG')">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 " v-for="(detalle,key3) in form.detContenidoTema" :key="key3" >
                        <a v-if="detalle.Tipo == 'ENLACEIMG'" :href="detalle.Enlace" target="_blank" rel="noopener">
                            <img :src="RutaFile+detalle.Archivo" class="d-block w-100 mb-3 effect2" alt="ENES">
                        </a>
                    </div>
                </div>

                <div class="row mt-3 list-icon" v-if="(form.detContenidoTema[0].Tipo == 'ENLACEBTN')">
                    <div :class="{ 'col-6 text-center': form.detContenidoTema.length>1, 'col-12 text-center': form.detContenidoTema.length == 1 }" v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                        <a :href="detalle.Enlace" target="_blank" class="button mb-3" tabindex="0">
                            <span :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''" ></span>
                            &nbsp; {{detalle.NombreBtnEnlace}} &nbsp;
                            <span :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></span>
                        </a>
                    </div>
                </div>
                

                <div class="form-group row list-icon" v-if="(form.detContenidoTema[0].Tipo == 'NORMAL')">
                    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                        <ul class="list-icon">
                            <li v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                                <a :href="detalle.Enlace" target="_blank" >{{detalle.Nombre}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="form-group row list-icon" v-if="(form.detContenidoTema[0].Tipo == 'PDFBOTON')">
                    <div :class="{ 'col-6 text-center': form.detContenidoTema.length>1, 'col-12 text-center': form.detContenidoTema.length == 1 }" v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                        <a download="" :href="RutaFile+detalle.Archivo" target="_blank" class="button mb-3" tabindex="0">
                            <span :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''" ></span>
                            &nbsp; {{detalle.NombreBtnEnlace}} &nbsp;
                            <span :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></span>
                        </a>
                    </div>
                </div>

                <span class="list-icon" v-if="(form.detContenidoTema[0].Tipo == 'PDFLINK')">
                    <ul >
                        <li v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                            <a :href="RutaFile+detalle.Archivo" target="_blank">{{detalle.Nombre}}</a>
                        </li>
                    </ul>
                </span>

            </div>


        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos'],
    data() {
        return {
            form:this.value
        }
    },methods: {
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },
}
</script>